import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  public _isLoading: boolean = false;
  public _isLoadingFull: boolean = false;


  show() {
    this._isLoading = true;
  }

  hide() {
    this._isLoading = false;
  }

  get isLoading(): boolean {
    return this._isLoading;
  }

  showFull() {
    this._isLoadingFull = true;
  }

  hideFull() {
    this._isLoadingFull = false;
  }

  get isLoadingFull(): boolean {
    return this._isLoadingFull;
  }
}
